export default {
  desktop: {
    startWidth: 1000,
  },
}
